import { Text } from '@chakra-ui/react';

export const SelloutCard = ({ title, value }) => {
    return (
        <Text fontSize={'xs'} bg={'white'} px={2} borderRadius={'4px'} border={'1px solid'} borderColor={'neutral.200'}>
            {value} {title}
        </Text>
    );
};
